<template>
  <!-- <full-calendar :events="events" :options="calendarOptions" />
   -->
  <div class="row">
    <div class="col-lg-12">
      <full-calendar
        :events="data"
        locale="ms-my"
        @moreClick="moreClick"
        @eventClick="eventClick"
        @dayClick="dayClick"
        class=""
        style="color: #000000 !important"
      >
      </full-calendar>
      <modal :show.sync="modals.noti" class="modal-calendar">
        <div class="modal-header-2">
          <div class="row">
            <div class="col-lg-8">
              <p>JOB INFORMATION - {{ tarikh }}</p>
            </div>
            <div class="col-lg text-right" style="padding: 1%">
              <base-button class="btn-icon btn-sm btn-round btn-cancel" @click="modals.noti = false"
                >x</base-button
              >
            </div>
          </div>
        </div>
        <div
          class="col-lg-12 text-center"
          style="background: #ffffff; margin-bottom: -10px; margin-top: 30px"
        >
          <el-table
            :data="tableData"
            :header-cell-style="{
              border: 'transparent',
              'font-size': '14px',
              'font-weight': '400',
              color: '#707070',
            }"
            :cell-style="{ fontColor: '#707070' }"
            :row-style="tableRowClassName"
            style="color: #707070"
          >
            <el-table-column>
              <div slot-scope="scope">
                <base-button
                  class="btn-icon btn-round btn-sm"
                  style="color: #ffffff; font-size: 13px"
                  >{{ scope.$index + 1 }}</base-button
                >
              </div>
            </el-table-column>
            <el-table-column label="Job No" prop="jobno"> </el-table-column>
            <el-table-column label="Customer" prop="customer">
            </el-table-column>
            <el-table-column label="Time" prop="time">
              <div slot-scope="{ row }">
                <el-time-picker
                  v-model="row.time"
                  placeholder="Select date"
                ></el-time-picker>
              </div>
            </el-table-column>
            <el-table-column label="Date" prop="start">
              <div slot-scope="{ row }">
                <el-date-picker
                  v-model="row.start"
                  placeholder="Select date"
                ></el-date-picker>
              </div>
            </el-table-column>
          </el-table>
          <!-- <p
            style="
              color: #5a5a5a;
              text-align: center;
              font-size: 28px;
              font-weight: 600;
            "
          >
            {{ title }}
          </p>
          <p
            style="
              color: #0baa00;
              text-align: center;
              font-size: 14px;
              font-weight: 600;
            "
          >
            {{ time }}
          </p> -->
        </div>
        <br />
        <div class="row">
          <div class="col-lg text-right">
            <base-button @click="submit()">Save Changes</base-button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import { Modal } from "src/components";
import { Table, TableColumn, TimePicker, DatePicker } from "element-ui";
import moment from "moment";

// import FullCalendar from "vue-fullcalendar";
// import fullCalendar from "vue-fullcalendar";

// var demoEvents = [
//   {
//     title: "Sunny Out of Office",
//     start: "2024-01-15",
//     end: "2024-01-15",
//     time: "09:00",
//     cssClass: ["onschedule"],
//   },
//   {
//     title: "Sunny Out of Office qwertyuiop",
//     start: "2024-01-15",
//     end: "2024-01-15",
//     time: "09:00",
//     cssClass: ["delay"],
//   },

//   {
//     title: "hewwo",
//     start: "2024-01-20",
//     end: "2024-01-20",
//     time: "13:00",
//     cssClass: ["delay"],
//   },
// ];

export default {
  name: "Calendar",
  props: {
    data: {
      type: Array,
      default: () => [],
      description: "Table data",
    },
  },
  components: {
    "full-calendar": require("vue-fullcalendar"),
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimePicker.name]: TimePicker,
  },
  data() {
    return {
      // fcEvents: demoEvents,
      // fcEvents:
      custom_calendar_class:
        "background: pink !important;width: 100% !important;height: 100% !important;",
      modals: {
        noti: false,
      },
      title: "",
      time: "",
      tarikh: "",
      tableData: [],
    };
  },
  methods: {
    submit(){
      console.log(this.tableData)
    },
    tableRowClassName({ row, rowIndex }) {
      // console.log(rowIndex % 2);
      if (rowIndex % 2 == 0) {
        let style = { background: "#f5f6fa", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#FFFFFF", color: "#959595" };
        return style;
      }
    },
    eventClick(event, jsEvent, pos) {
      console.log("event click");

      console.log(event);
      console.log(jsEvent);
      console.log(pos);
      this.tableData = [
        {
          customer: event.customer,
          jobno: event.jobno,
          start: event.start,
          end: event.end,
          time: event.time,
        },
      ];
      // this.title = event.title;
      this.tarikh = moment(event.start, "YYYY-MM-DD").format("DD MMMM YYYY");
      this.modals.noti = true;
    },
    dayClick(day, jsEvent) {
      console.log(" day click");
      console.log(day);
    },
    moreClick(date, events, jsEvent) {
      console.log(date);
      console.log(events);
    },
  },
};
</script>

<style>
.onschedule {
  background: rgb(11, 170, 0) !important;
  color: #ffffff !important;
  /* width: 5%;
  height: 40px !important; */
}

.delay {
  background: rgb(255, 153, 0) !important;
  color: #ffffff !important;
}


.wastecollection {
  background: rgb(54, 141, 204) !important;
  color: #ffffff !important;
}
.chosen {
  background: rgb(54, 141, 204) !important;
  color: #ffffff !important;
}

/* 
.red {
  background: rgb(235, 77, 77) !important;
  color: whitesmoke !important;
}
.blue {
  background: rgb(59, 59, 163) !important;
  color: whitesmoke !important;
}
.orange {
  background: orange !important;
  color: white !important;
}
.green {
  background: rgb(49, 155, 49) !important;
  color: white !important;
}
.blue,
.orange,
.red,
.green {
  font-size: 13px;
  font-weight: 500;
  text-transform: capitalize;
} */
.event-item {
  padding: 2px 0 2px 4px !important;
}
/* .custom_calendar_class {
  background: pink !important;
  width: 100% !important;
  height: 100% !important;
  position: absolute;
} */
</style>
